
export const projects = [
  {
    id: 1,
    slug: 'crm-platform-redesign',
    no: '01',
    title: 'CRM Platform Redesign',
    tags: ['Fintech Project', 'Shipped'],
    statusColor: 'shipped',
    description: "Redesigned a large-scale CRM platform used by 3M+ relationship managers, enabling efficient management of a billion+ customer relationships across the banking ecosystem.",
    role: 'Product Designer',
    team: 'PM, PO, Dev, QA',
    timeframe: 'Sept 2023 - Nov 2025',
    color: '#e8d5b7',
    video: 'portfolio/work/crm-platform-redesign/Cover_1_encnlj',
  },
  {
    id: 2,
    slug: 'ai-document-extraction-for-crm',
    no: '02',
    title: 'AI Document Extraction for CRM',
    tags: ['Fintech Project', 'Shipped', "AI"],
    statusColor: 'shipped',
    description: "Designed an AI-powered document extraction solution within the CRM platform, eliminating manual form filling for relationship managers and accelerating customer onboarding workflows.",
    role: 'Product Designer',
    team: 'PM, PO, Dev',
    timeframe: 'Oct - Nov 2025',
    color: '#fde2e4',
    video: 'portfolio/work/ai-document-extraction-for-crm/Cover_2_g5ufkr',
  },
  {
    id: 3,
    slug: 'agentic-dashboard',
    no: '03',
    title: 'Agentic Dashboard',
    tags: ['Agentic AI', 'Shipped'],
    statusColor: 'shipped',
    description: "Designed end-to-end Agentic AI experiences, including admin workflows for AI configuration and training, and relationship manager workflows focused on consuming AI-generated insights and actions.  ",
    role: 'Product Designer',
    team: 'PM, PO, Dev, Analyst',
    timeframe: 'Apr - May 2025',
    color: '#faf8f3',
    video: 'portfolio/work/agentic-dashboard/Cover_3_cfcvsc',
  },
  {
    id: 4,
    slug: 'route-planner-mobile-app',
    no: '04',
    title: 'Route Planner (Mobile App)',
    tags: ['Mobile App', 'Shipped', "AI" ],
    statusColor: 'shipped',
    description: 'Built a mobile solution for FOS teams that simplified daily route planning, reduced travel inefficiencies, and helped relationship managers maximize customer interactions.',
    role: 'Product Designer',
    team: 'PM, PO, Dev',
    timeframe: 'Dec 2024 - Nov 2025',
    color: '#e7e5d8',
    video: 'portfolio/work/route-planner-mobile-app/Cover_4_clt6dl',
  },
  {
    id: 5,
    slug: 'crm-design-system',
    no: '05',
    title: 'CRM Design System',
    tags: ['Design System', 'Enterprise', 'Shipped'],
    statusColor: 'shipped',
    description: 'Created a scalable atomic design system for a fintech CRM platform, ensuring consistency, accessibility, and faster product development across teams.',
    role: 'Product Designer',
    team: 'Design Team, Dev',
    timeframe: 'Sept 2023 - Nov 2025',
    color: '#cfe6f8',
    thumbnail: 'portfolio/work/crm-design-system/1_vlkkqi',
  }
];

export const navItems = [
  { no: '01', label: 'My Work', path: '/home' },
  { no: '02', label: 'About Me', path: '/about' },
  { no: '03', label: 'Sketchbook', path: '/sketchbook' },
  { no: '04', label: 'Visitor Gallery', path: '/visitor-gallery', badge: true },
];

export const findMeLinks = [
  { label: 'Email', href: 'mailto:manishapundirdesign@gmail.com' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/manishapundir/' },
  { label: 'Resume', href: '/ManishaPundirResume.pdf' },
];

/** Sketchbook page — Cloudinary public IDs under portfolio/sketchbook/ */
export const sketchbookImages = [
  { src: 'portfolio/sketchbook/1_gmymuk', alt: 'Sketch description' },
  { src: 'portfolio/sketchbook/2_ltubw8', alt: 'Sketch description' },
  { src: 'portfolio/sketchbook/3_q4vqgu', alt: 'Sketch description' },
  { src: 'portfolio/sketchbook/4_grducw', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/5_owc8zq', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/6_onpoxu', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/7_sobbdr', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/8_lb9woy', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/10_tw0sl6', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/11_nwffk9', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/12_ffzimo', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/13_rannfh', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/14_hh5fvx', alt: 'Sketch description' },  
  { src: 'portfolio/sketchbook/15_alc8du', alt: 'Sketch description' },        
];

export const favorites = {
  Anime: [
    { title: 'Demon Slayer: Kimetsu no Yaiba', color: '#7a3a3a', image: 'portfolio/about/Demon_Slayer_k5rmfp' },
    { title: 'Fruits Basket', color: '#e8a55a', image: 'portfolio/about/Fruits_Basket_btqh4o' },
    { title: 'Solo Leveling', color: '#1f4e7a', image: 'portfolio/about/Solo_Leveling_rdki5b' },
    { title: 'Naruto', color: '#f0c674', image: 'portfolio/about/Naruto_xnjupu' },
  ],
  Novels: [
    { title: 'Kite Runner', author: 'Khaled Hosseini', color: '#1a1450', image: 'portfolio/about/Kite_Runner_kboycw' },
    { title: 'Home Body', author: 'Rupi Kaur', color: '#c4757e', image: 'portfolio/about/Home_Body_nmj53v' },
    { title: 'Let It Snow', author: 'John Green, Maureen Johnson, Lauren Myracle', color: '#5a7faf', image: 'portfolio/about/Let_It_Snow_apx1ou' },
    { title: 'Shantaram', author: 'Gregory David Roberts', color: '#3a3a3a', image: 'portfolio/about/Shantaram_rljtl2' },
  ],
  Series: [
    { title: 'Empress Ki', color: '#5a7faf', image: 'portfolio/about/Empress_Ki_g8lkj7' },
    { title: 'Hidden Love', color: '#c4757e', image: 'portfolio/about/Hidden_Love_vt84fc' },
    { title: 'Pursuit of Jade', color: '#1a4a3a', image: 'portfolio/about/pursuit_of_jade_madvoj'},
    { title: 'Off Campus', color: '#3a3a8a', image: 'portfolio/about/offcampus_dy59re' },
  ],
};

/** About page portraits — Cloudinary public IDs under portfolio/site/about/ */
export const aboutPortraits = [
  { src: 'portfolio/about/IMG_1283_fnsqla', alt: 'Manisha', width: 1284, height: 2282, align: 'end' },
  { src: 'portfolio/about/iAHOH8RF0nBejgLqrujWZadeL4_pbu5zs', alt: 'Manisha', width: 1000, height: 1000, align: 'center' },
  { src: 'portfolio/about/TNsl0BaqtHQYG2oseF3S28mOgKQ_kovqdn', alt: 'Manisha', width: 1284, height: 2282, align: 'start' },
];

export const communities = [
  {
    icon: '✦',
    name: 'RhythmQ',
    description: "I’m currently building a forum and mentorship platform for nonprofit clients — designing spaces that help people connect, learn, and grow in their careers.",
    bg: '#f4e4d4',
  },
  {
    icon: '◇',
    name: 'BusinessNext',
    description: "At BusinessNext, I led the redesign of an end-to-end CRM platform, focusing on making customer data easy to understand and act on. Through research, rapid prototyping, and usability testing, I was able reduce iteration time by 80% and delivered intuitive, high-impact solutions aligned with both user and business goals.",
    bg: '#fce8e8',
  },
  {
    icon: '◇',
    name: 'Earlier',
    description: "Before moving into enterprise product design, I created campaigns, visuals, and brand experiences in the advertising space.",
    bg: '#dbe7f3',
  },
];

export const visitorAdjectives = ['twilight', 'nutmeg', 'starlit', 'pearl', 'violet', 'opal', 'meadow', 'little', 'mossy', 'flower', 'mulberry', 'dusky', 'scarlet', 'merry', 'peach', 'cloudy', 'vanilla', 'salt', 'amber', 'tangerine', 'lovely', 'blushing'];
export const visitorNouns = ['figure', 'sparrow', 'bookmark', 'reverie', 'cartographer', 'dreamer', 'wren', 'inkwell', 'queen', 'thimble', 'sketcher', 'meadowlark', 'grove', 'storyteller', 'fairy', 'wanderer', 'drifter', 'philosophist', 'moonchild', 'petal'];

export const hats = [
  { name: 'Sprout', count: 336 },
  { name: 'Party', count: 288 },
  { name: 'Cap', count: 172 },
  { name: 'Bucket', count: 148 },
  { name: 'Top Hat', count: 73 },
];

export const colorPicks = [
  { name: 'Pink', pct: 27, color: '#e8a5a8' },
  { name: 'Orange', pct: 23, color: '#e8b88a' },
  { name: 'Teal', pct: 23, color: '#7eb8b8' },
  { name: 'Green', pct: 23, color: '#9bc28a' },
];

export function generateVisitorName() {
  const adj = visitorAdjectives[Math.floor(Math.random() * visitorAdjectives.length)];
  const noun = visitorNouns[Math.floor(Math.random() * visitorNouns.length)];
  return `${adj} ${noun}`;
}

export const initialVisitors = Array.from({ length: 18 }).map((_, i) => ({
  id: 5313 - i,
  name: generateVisitorName(),
  date: i < 12 ? '05/24/26' : i < 15 ? '05/23/26' : i < 17 ? '04/19/26' : '04/16/26',
  variant: i % 3,
  signed: i % 4 === 0,
}));
